import React, { useState, useEffect } from 'react';
import { FaFacebook, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import { IoMailUnread } from "react-icons/io5";
import { IoLogoLinkedin } from "react-icons/io";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/Navbar.css';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import logo from '../../src/assets/images/logo-tt.png'
import wattsappicon from '../../src/assets/images/wattsap2.png'

const Navbar = () => {
  const [isNavbarOpen, setNavbarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleNavbar = () => {
    setNavbarOpen(!isNavbarOpen);
  };

  return (
    <>
      {/* Top Bar */}
      <header className="top-bar" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="container">
          <div className="top-bar-content">
            <div className="top-bar-left">
              <Link to="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="top-bar-link">
                <FaMapMarkerAlt className="top-bar-icon" />
                <span>Collabs Lahore, Gulberg III, Lahore, Pakistan</span>
              </Link>
              <Link to="mailto:info@techsoltech.com" target="_blank" rel="noopener noreferrer" className="top-bar-link">
                <IoMailUnread className="top-bar-icon" />
                <span>info@techsoltech.com</span>
              </Link>
            </div>
            
            <div className="top-bar-right">
              <span className="top-bar-text">Follow Us:</span>
              <div className="social-links">
                <Link to="https://wa.me/923193284118" target="_blank" className="social-link">
                  <img width="20" height="20" src={wattsappicon} alt="WhatsApp"/>
                </Link>
                <Link to="https://www.facebook.com/profile.php?id=61571234807734" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FaFacebook />
                </Link>
                <Link to="https://www.linkedin.com/company/techsoltech/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <IoLogoLinkedin />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Navigation */}
      <nav className={`main-nav ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="nav-content">
            {/* Logo */}
            <Link className="nav-brand" to="/" style={{ marginRight: '20px' }}>
              <img src={logo} alt="Techsol Technologies" className="nav-logo" />
            </Link>

            {/* Mobile Toggle */}
            <button
              className="nav-toggle"
              type="button"
              onClick={toggleNavbar}
              aria-label="Toggle navigation"
            >
              <span className="nav-toggle-bar"></span>
              <span className="nav-toggle-bar"></span>
              <span className="nav-toggle-bar"></span>
            </button>

            {/* Navigation Menu */}
            <div className={`nav-menu ${isNavbarOpen ? 'active' : ''}`}>
              <ul className="nav-links mt-md-auto mt-4">
                <li className="nav-item">
                  <NavLink 
                    className="nav-link" 
                    to="/"
                    onClick={() => setNavbarOpen(false)}
                  >
                    <span className="nav-link-text">Home</span>
                  </NavLink>
                </li>
                
                <li className="nav-item">
                  <NavLink 
                    className="nav-link" 
                    to="/services"
                    onClick={() => setNavbarOpen(false)}
                  >
                    <span className="nav-link-text">Services</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink 
                    className="nav-link" 
                    to="/partner-program"
                    onClick={() => setNavbarOpen(false)}
                  >
                    <span className="nav-link-text">Partner Program</span>
                  </NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink 
                    className="nav-link" 
                    to="/projects"
                    onClick={() => setNavbarOpen(false)}
                  >
                    <span className="nav-link-text">Projects</span>
                    <span className="nav-indicator"></span>
                  </NavLink>
                </li> */}
                <li className="nav-item">
                  <NavLink 
                    className="nav-link" 
                    to="/about"
                    onClick={() => setNavbarOpen(false)}
                  >
                    <span className="nav-link-text">About Us</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink 
                    className="nav-link" 
                    to="/contact"
                    onClick={() => setNavbarOpen(false)}
                  >
                    <span className="nav-link-text">Contact</span>
                  </NavLink>
                </li>
              </ul>

              {/* Contact Info */}
              <div className="nav-contact">
                <div className="contact-info">
                  <div className="contact-icon">
                    <FaPhoneAlt />
                  </div>
                  <div className="contact-details">
                    <span className="contact-label">Hot Line Number</span>
                    <Link to="https://wa.me/923193284118" target='blank' className="contact-number">
                      +92 319 32 84 118
                    </Link>
                  </div>
                </div>
                
                <Link 
                  to="/contact" 
                  className="cta-button-navbar"
                  onClick={() => setNavbarOpen(false)}
                >
                  <span>Get Quote</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;